import axios from 'axios';
import { getToken } from 'helpers';
import { API } from '../constants';
import { paramsSerializer } from '../utils';

export const axiosInstance = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Csrf-Token': getToken()
  }
});

export const fetcher = async (url: string) => {
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch data');
  }
};

export const logout = async () => {
  try {
    const response = await axiosInstance.delete(API.LOGOUT);
    return response.data;
  } catch (error) {
    throw new Error('Failed to logout');
  }
};

export const fetchCatalogData = async (params: Record<string, unknown>) => {
  try {
    const response = await axiosInstance.get(API.CATALOG, {
      params: { ...params, is_key: true },
      paramsSerializer
    });
    return response.data;
  } catch {
    throw new Error('Failed to fetch catalog data');
  }
};
